// extracted by mini-css-extract-plugin
export var backupIcon = "_q6-1";
export var image = "_q6-0";